import React,{ useEffect, useState } from 'react';
import { useSubmit,useActionData } from 'react-router-dom';
import { userRegister } from '../api';
import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap';
import Input from './Input';
import { convert_to_json } from '../utils/utils.js'

export const action = async({ request }) => {

    try{

        const formData = await request.formData();
        const data = convert_to_json(formData);

        data.password = btoa(data.password);
        data.password_confirm = "";

        await userRegister(data);

        return null;
    }
    catch(exeption){
        return exeption
    }
    
}

function FormRegister(props) {

    const response = useActionData();
    let submit = useSubmit();

    const MESSAGE_REQUERID = "Complete los campos obligatorios.";

    const [validated, setValidated] = useState(false);
    const [notification,set_notification] = useState({show:false,statu:"danger",message:MESSAGE_REQUERID});
    const [checkValidity,set_checkValidity] = useState(false);

     const [fields,set_fields] = useState([
        { 
            name:"name",             
            type:"text",     
            label:"Nombres",              
            placeholder:"Ingrese su nombres",                
            value:"", 
            required:true, 
            min:3,
            checkValidity:false,
            isInvalid:false,
            isValid:false,

        },
        { 
            name:"last_name",        
            type:"text",     
            label:"Apellidos",            
            placeholder:"Ingrese su apellidos",              
            value:"", 
            required:true,
            min:3, 
            checkValidity:false,
            isInvalid:false,
            isValid:false,
        },
        { 
            name:"email",            
            type:"email",     
            label:"Correo Electrónico",  
            placeholder:"Ingrese su correo electrónico",     
            value:"", 
            required:true, 
            checkValidity:false,
            isInvalid:false,
            isValid:false,
        },
        { 
            name:"password",         
            type:"password", 
            label:"Contraseña",           
            placeholder:"Ingrese una contraseña",            
            value:"", 
            required:true,
            min:6, 
            checkValidity:false,
            isInvalid:false,
            isValid:false,
        },
        { 
            name:"password_confirm", 
            type:"password", 
            label:"Confirmar Contraseña", 
            placeholder:"Ingrese confirmación de contraseña",
            value:"", 
            required:true,
            min:6,  
            compare:"password",
            checkValidity:false,
            isInvalid:false,
            isValid:false,
        },
    ]);

    const update_field = (index, keys, newValues) => {
        set_fields(prevFields => {
            const updatedFields = [...prevFields];
            const field = { ...updatedFields[index] };
    
            keys.forEach((key, i) => { 
                field[key] = newValues[i]; 
            });
    
            updatedFields[index] = field;
            return updatedFields;
        });
    };

    // const message =(message) => set_notification({ ...notification, show:true, message: message });

    const handle_change = () => {}

    useEffect(()=>{

        if(response !== undefined){

            if(response !== null){
                //bad request......
                setValidated(false);

                // message(response.message);
                set_notification({ ...notification, show:true, message: response.message });
                if(response.validations !== undefined){
                    response.validations.forEach(validation => {
                        const index = fields.findIndex(x=> x.name === validation.name);
                        update_field(index,["isInvalid","message"],[true,validation.message]);
                        
                    });
                }
                 return;

            }
             
            const email = document.getElementById("txtemail");
            props.onSuccess({ email: email.value });
        }
       
    // eslint-disable-next-line
    },[response]);

    useEffect(()=>{

            set_checkValidity(true);

    },[fields]);

    const handleSubmit = (event) => {

         const form = event.currentTarget;
         setValidated(true);
         event.preventDefault();
         event.stopPropagation();

         
         if (form.checkValidity() && checkValidity) {

            submit(form);
         }
    };

  return (
   <>
    <Container>
        <Form id='frmRegister' name='frmRegister' method='POST' noValidate validated={validated} onSubmit={handleSubmit} autoComplete='off'>
           
           {fields.map((field,index) =>(

                <Row key={`r${field.name}`}>
                    <Col className='m-2'>
                        <Input 
                            key             = { field.name } 
                            id              = { `txt${field.name}` }
                            name            = { field.name } 
                            type            = { field.type }
                            label           = { field.label } 
                            placeholder     = { field.placeholder } 
                            required        = { field.required } 
                            min             = { field.min }
                            max             = { field.max }
                            compare         = { field.compare }
                            message         = { field.message }
                            isInvalid       = { field.isInvalid }
                            isValid         = { field.isValid }
                            onChange        = { (e,isValid) => handle_change(index, e.target.value,isValid) }
                        />
                    </Col>
                </Row>
           ))}
            

            <Row style={{display:notification.show ? "inline" : "none"}}>
                <Col>
                    <Alert style={{
                        "fontSize":"12px",
                        "backgroundColor": "#dc3545",
                        "color" : "white",
                    }} variant={notification.statu}>{notification.message}</Alert>
                </Col>
            </Row>

            <Row className='justify-content-start'>
                <Col className='m-2'>
                    <Button type="submit" style={{display:"table",marginRight:"auto",marginLeft:"auto"}}>Crear Cuenta</Button>
                </Col>
            </Row>
        </Form>
    </Container>
           
    </>
  )
}

export default FormRegister